import { render, staticRenderFns } from "./ManageAffiliate.vue?vue&type=template&id=abc5a9ba&scoped=true"
import script from "./ManageAffiliate.vue?vue&type=script&lang=js"
export * from "./ManageAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc5a9ba",
  null
  
)

export default component.exports